import { useQuery } from '@tanstack/react-query'
import { apiGetAllNews } from '@/services/newsHome/api'
import { GetAllNewsPayload, GetAllNewsResponse } from '@/services/newsHome/type'

const MEDIA_NEWS_NEWTYPE_ID = Number(process.env.NEXT_PUBLIC_MEDIA_NEWS_NEWTYPE_ID)

const HOME_NEWS_PAYLOAD: GetAllNewsPayload = {
    keywords: '',
    newsTypeId: MEDIA_NEWS_NEWTYPE_ID,
    isPublic: '',
    page: 1,
    pageSize: 12,
} as const

export const useGetAllNewsQuery = () => {
    return useQuery<GetAllNewsResponse>({
        queryKey: ['news', 'home-list'],
        queryFn: () => apiGetAllNews(HOME_NEWS_PAYLOAD),
        placeholderData: (previousData) => previousData,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    })
}